export let LineItemType = /*#__PURE__*/function (LineItemType) {
  LineItemType["Automatic"] = "automatic";
  LineItemType["Manual"] = "manual";
  LineItemType["Credit"] = "credit";
  LineItemType["AdHocCharge"] = "adHocCharge";
  return LineItemType;
}({});